<template>
    <div class="kt-portlet">

        <div class="kt-portlet__body" style="color: white; background-color: #0a6aa1">
            <h6>{{ title }}</h6>
            <div class="text-center"><h2 class="fix-margin">{{ user_data }}</h2></div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex"

    export default {
        name: "user_compo",

        props: {
            user_data: {
                default() {
                    return {}
                }
            },
            title: {
                default() {
                    return {}
                }
            },
        },
    }
</script>

<style scoped>

</style>